<template>
    <v-skeleton-loader :loading="loadingdata && routerenter == true" type="table" v-if="loggedin">
      <v-data-table :single-expand="(singleexpand == 'true'? visible_status : hidden_status)" :expanded.sync="expanded" :item-key="itemkeyvalue" :show-expand="(showexpandstatus == 'true'? visible_status : hidden_status)" :headers="headers" :items="items" :hide-default-footer="(footerstatus=='false'? visible_status : hidden_status)" :search="search" :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]  }" class="elevation-1">
         <template slot="no-data">
            {{ 'No data available' | translate }}
        </template>
        <template v-slot:item.revokeaction="{ item }">
          <v-icon small v-if="actiontitle == 'Coupons' && item.status =='unused'" class="mr-2" v-on:click="handleRevoke(item.coupon_id)" >mdi-close-circle</v-icon>
          <v-icon small v-if="actiontitle == 'Coupons' && (item.status !='unused')" class="mr-2">mdi-minus</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <!-- Editing -->
          <v-icon small v-if="item.user_id!== undefined && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-update-users') || currentUser.permissions.includes('can-assign-custom-role'))" class="mr-2" v-on:click="handleClick(item.user_id)">edit</v-icon>
          <v-icon small v-if="(item.equipment_id!== undefined && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-update-equipment')))" class="mr-2" v-on:click="handleClick(item.equipment_id)">edit</v-icon>
          <v-icon small v-if="((item.group_id!== undefined) &&  (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-update-group'))))" class="mr-2" v-on:click="handleClick(item.group_id)">edit</v-icon>
          <v-icon small v-if="(item.equip_group_id!== undefined && actiontitle != 'Equipment' &&(currentUser.roles.includes(1) || currentUser.permissions.includes('can-update-equipment-group')))" class="mr-2" v-on:click="handleClick(item.equip_group_id)">edit</v-icon>
          <v-icon small v-if="(item.temp_id!== undefined && actiontitle == 'Equipment Template'  && (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-update-equipment-template'))))" class="mr-2" v-on:click="handleClick(item.temp_id)">edit</v-icon>
          <v-icon small v-if="(item.temp_id!== undefined && actiontitle == 'Personal Template' && (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-update-personal-template'))))" class="mr-2" v-on:click="handleClick(item.temp_id)">edit</v-icon>
          <v-icon small v-if="(item.tc_group_id!== undefined  && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-update-test-case-group')))" class="mr-2" v-on:click="handleClick(item.tc_group_id)">edit</v-icon>
          <v-icon small v-if="(item.temp_id!== undefined && actiontitle == 'Task template' &&  (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-update-test-case-group'))))" class="mr-2" v-on:click="handleClick(item.temp_id)">edit</v-icon>
          <v-icon small v-if="(item.tc_id!== undefined && (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-update-test-case'))))" class="mr-2" v-on:click="handleClick(item.tc_id)">edit</v-icon>
          <v-icon small v-if="((item.question_id!== undefined)&&(currentUser.permissions.includes('can-update-question') || currentUser.roles.includes(1) || currentUser.roles.includes(3)))" class="mr-2" v-on:click="handleClick(item.question_id)">edit</v-icon>
          <v-icon small v-if="((item.quiz_id!== undefined)&&(currentUser.permissions.includes('can-update-quiz') || currentUser.roles.includes(1) || currentUser.roles.includes(3)))" class="mr-2" v-on:click="handleClick(item.quiz_id)">edit</v-icon>
          <v-icon small v-if="((item.custom_role_id!== undefined) && (currentUser.permissions.includes('can-update-custom-role') || currentUser.roles.includes(1) || currentUser.roles.includes(3)))" class="mr-2" v-on:click="handleClick(item.custom_role_id)">edit</v-icon>
          <v-icon small v-if="((item.id!== undefined) && ( currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-system-mails')))" class="mr-2" v-on:click="handleClick(item.id)">edit</v-icon>
          <v-icon small v-if="((item.sc_temp_id!== undefined) && ( currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-scheduled-mails')))" class="mr-2" v-on:click="handleClick(item.sc_temp_id)">edit</v-icon>
          <v-icon small v-if="((item.tg_temp_id!== undefined) && ( currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-trigger-mails')))" class="mr-2" v-on:click="handleClick(item.tg_temp_id)">edit</v-icon>
          <v-icon small v-if="((item.rm_temp_id!== undefined) && ( currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-reminder-mails')))" class="mr-2" v-on:click="handleClick(item.rm_temp_id)">edit</v-icon>
          <v-icon small v-if="((item.page_id!== undefined) && ( currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-additional-pages')))" class="mr-2" v-on:click="handleClick(item.page_id)">edit</v-icon>

          <!-- Viewing -->
          <v-icon small v-if="item.user_id!== undefined && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('can-audit-user-history'))" class="mr-2" v-on:click="handleView(item.user_id)">mdi-eye</v-icon>

          <!-- Deleting -->
          <v-icon small v-if="(item.tc_id!== undefined && (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-delete-test-case'))))" class="mr-2" v-on:click="handleDelete(item.tc_id)" >delete</v-icon>
          <v-icon small v-if="(item.temp_id!== undefined  && actiontitle == 'Task template' &&  (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-delete-test-case-group'))))" class="mr-2" v-on:click="handleDelete(item.temp_id)" >delete</v-icon>
          <v-icon small v-if="(item.tc_group_id!== undefined  && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-delete-test-case-group')))" class="mr-2" v-on:click="handleDelete(item.tc_group_id)" >delete</v-icon>
          <v-icon small v-if="(item.temp_id!== undefined && actiontitle == 'Personal Template' && (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-delete-personal-template'))))" class="mr-2" v-on:click="handleDelete(item.temp_id)" >delete</v-icon>
          <v-icon small v-if="(item.equip_group_id!== undefined && actiontitle != 'Equipment' && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-delete-equipment-group')))" class="mr-2" v-on:click="handleDelete(item.equip_group_id)" >delete</v-icon>
          <v-icon small v-if="(item.temp_id!== undefined && actiontitle == 'Equipment Template' && (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-delete-equipment-template'))))" class="mr-2" v-on:click="handleDelete(item.temp_id)" >delete</v-icon>
          <v-icon small v-if="item.user_id!== undefined && currentUser.roles.includes(1)" class="mr-2" v-on:click="handleDelete(item.user_id)" >delete</v-icon>
          <v-icon small v-if="(item.equipment_id!== undefined && (currentUser.roles.includes(1) || currentUser.permissions.includes('can-delete-equipment')))" class="mr-2" v-on:click="handleDelete(item.equipment_id)" >delete</v-icon>
          <v-icon small v-if="((item.group_id!== undefined) &&  (currentUser.roles.includes(1) || (currentUser.permissions.includes('can-delete-group'))))" class="mr-2" v-on:click="handleDelete(item.group_id)" >delete</v-icon>
          <v-icon small v-if="((item.question_id!== undefined)&&(currentUser.permissions.includes('can-delete-question') || currentUser.roles.includes(1) || currentUser.roles.includes(3)))" class="mr-2" v-on:click="handleDelete(item.question_id)" >delete</v-icon>
          <v-icon small v-if="((item.quiz_id!== undefined)&&(currentUser.permissions.includes('can-delete-quiz') || currentUser.roles.includes(1) || currentUser.roles.includes(3)))" class="mr-2" v-on:click="handleDelete(item.quiz_id)" >delete</v-icon>
          <v-icon small v-if="((item.custom_role_id!== undefined) && (currentUser.permissions.includes('can-delete-custom-role') || currentUser.roles.includes(1) || currentUser.roles.includes(3)))" class="mr-2" v-on:click="handleDelete(item.custom_role_id)" >delete</v-icon>
          <v-icon small v-if="((item.id!== undefined) && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-system-mails')))" class="mr-2" v-on:click="handleDelete(item.id)" >delete</v-icon>
          <v-icon small v-if="((item.sc_temp_id!== undefined) && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-scheduled-mails')))" class="mr-2" v-on:click="handleDelete(item.sc_temp_id)" >delete</v-icon>
          <v-icon small v-if="((item.tg_temp_id!== undefined) && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-trigger-mails')))" class="mr-2" v-on:click="handleDelete(item.tg_temp_id)" >delete</v-icon>
          <v-icon small v-if="((item.rm_temp_id!== undefined) && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-reminder-mails')))" class="mr-2" v-on:click="handleDelete(item.rm_temp_id)" >delete</v-icon>
          <v-icon small v-if="((item.resource_id!== undefined) && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-additional-pages-resource') ))" class="mr-2" v-on:click="handleDelete(item.resource_id)" >delete</v-icon>
          <v-icon small v-if="((item.page_id!== undefined) && (currentUser.roles.includes(1) || currentUser.roles.includes(3) || currentUser.permissions.includes('has-access-to-additional-pages')))" class="mr-2" v-on:click="handleDelete(item.page_id)" >delete</v-icon>
       
        </template>
        <template v-slot:item.details="{ item }"   >
            <v-btn small :color="primary_color" v-on:click="handleDetails(item.id)">{{ 'Details'| translate }}</v-btn>
        </template>
        <template v-slot:item.quizresponse="{ item }" >
          <td>{{ item.result.response.substring('urn:scormdriver:'.length) }}</td>
        </template> 
        <template v-slot:item.status="{ item }">
          <td style="border-bottom: 0px solid rgba(0, 0, 0, 0.12); color: green; " v-if="item.status=='active'">{{ item.status | translate }}</td>
          <td style="border-bottom: 0px solid rgba(0, 0, 0, 0.12); color: red;" v-if="item.status=='disable'"> {{ item.status | translate }}</td>
          <td style="border-bottom: 0px solid rgba(0, 0, 0, 0.12); color: blue;" v-if="item.status=='pending'"> {{ item.status | translate }}</td>
        </template>
        <template v-slot:item.linktouser="{ item }"   >
            <v-btn small class="white--text" :color="primary_color" v-if="item.temp_type=='personal'"  @click="openDocumentModal({templatedata: item, title: 'Update document', updateMessage: 'Personal template updated successfully', updateSlug: 'user-documents' })">{{ 'Update document'| translate }}</v-btn>
            <v-btn small class="white--text" :color="primary_color" v-if="item.temp_type=='equipment'" @click="openDocumentModal({templatedata: item, title: 'Update callibration template', updateMessage: 'Callibration document added successfully', updateSlug: 'user-documents' })">{{ 'Update document'| translate }}</v-btn>
            <v-btn small class="white--text" :color="primary_color" v-if="item.temp_type=='test-case'" @click="openDocumentModal({templatedata: item, title: 'Update task document', updateMessage: 'Task document added successfully',updateSlug: 'user-documents' })">{{ 'Update document'| translate }}</v-btn>
        </template>
        <template v-slot:item.createdocumentaction="{ item }"   >
            <v-btn small class="white--text" :color="primary_color" v-if="item.temp_type=='personal'"  @click="openDocumentModal({templatedata: item, title: 'Update document', updateMessage: 'Personal template updated successfully', updateSlug: 'templates/personal/' })">{{ 'Create document'| translate }}</v-btn>
            <v-btn small class="white--text" :color="primary_color" v-if="item.temp_type=='equipment'" @click="openDocumentModal({templatedata: item, title: 'Update callibration template', updateMessage: 'Callibration document added successfully', updateSlug: 'user-documents' })">{{ 'Create document'| translate }}</v-btn>
            <v-btn small class="white--text" :color="primary_color" v-if="item.temp_type=='test-case'" @click="openDocumentModal({templatedata: item, title: 'Update task document', updateMessage: 'Task document added successfully', updateSlug: 'user-documents' })">{{ 'Create document'| translate }}</v-btn>
        </template>
        <template v-slot:item.changestatus="{ item }"   >
          <v-switch v-model="item.is_active"  @change="changeState(item)" :label="(item.is_active  ? 'Active' : 'Inactive') | translate"></v-switch>
        </template> 
        <template v-slot:item.roles="{ item }">
            <v-chip text-color="white" small :color="getRoleColor(role)" class="mr-1 pa-2" v-for="(role, index) in item.roles" :key="index">
              {{role | translate}}
            </v-chip>
        </template> 
        <template v-slot:item.reminder_event="{ item }">
            {{item.reminder_event | translate}}
        </template> 
        <template v-slot:item.frequency="{ item }">
            {{item.frequency | translate}}
        </template>
        <template v-slot:item.page_type="{ item }">
            {{item.page_type | translate}}
        </template> 
        <template v-slot:item.question_type="{ item }">
            {{item.question_type | translate}}
        </template> 
        <template v-slot:item.custom_roles="{ item }">
            <v-chip small class="mr-1 pa-2" v-for="(role, index) in item.custom_roles" :key="index">
            {{role | translate}}
          </v-chip>
        </template>
        <template v-slot:item.permissions="{ item }">
          <v-chip small class="mr-1 pa-2" v-for="(permission, index) in item.permissions" :key="index">
            {{permission.permission_name | translate}}
          </v-chip>
        </template> 
        <template v-slot:item.name="{ item }">
            <a v-if="item.user_id!== undefined && (currentUser.roles.includes(1)|| currentUser.roles.includes(3) || currentUser.permissions.includes('can-audit-user-history'))" v-on:click="handleView(item.user_id)"> {{ item.name }}</a>
            <span v-else> {{ item.name }}</span>
        </template> 
        <template v-slot:item.quizactions>
            <v-btn small class="white--text" :color="primary_color">{{ 'Jump to quiz'| translate }}</v-btn>
        </template>          
        <template v-slot:item.thumbnail="{ item }">
          <div class="my-2">
            <v-img
              :src="storage_url+item.thumbnail"
              :alt="item.title"
              height="80px"
              width="70px"
            ></v-img>
          </div>
        </template>
        <template v-slot:item.data-table-expand="{ item ,expand, isExpanded }">
          <v-icon v-if="!isExpanded" @click="expand(!isExpanded); showDocuments(item.user_id)">mdi-chevron-down</v-icon>
          <v-icon v-if="isExpanded" @click="expand(!isExpanded)">mdi-chevron-up</v-icon>
        </template>
        <template v-slot:expanded-item="{ headers }">
          <td :colspan="headers.length" style='padding: 0px !important;' v-if="userdocuments.length >0" >
          <DataTable
            :title="userdocumenttitle"
            :headers="userdocumentheaders"
            :items="userdocuments"
            :singleexpand="userdocumentexpandable"
            :search="searchuser"
            :footerstatus="hidefooteruser"
          />   
          </td> 
          <td :colspan="headers.length" style='padding: 0px !important;' v-else >
            {{'No user documents' | translate}}
          </td>                
        </template>
        <template v-slot:item.statement_query="{item}">
          <td style="border-bottom: 0px solid rgba(0, 0, 0, 0.12);">{{ item.statement_query | translate }}</td>
        </template>
        <template v-slot:item.join_date="{item}">
          <div v-if="item.join_date == null" class="text-start">
              <v-chip color="red" text-color="white">
               {{ 'Pending' | translate }} 
              </v-chip>
          </div>
          <div class="text-start">
            {{item.join_date}}
          </div>
        </template>      
          <template v-slot:top v-if="title != 'subdocuments'">
          <v-card-title v-if="title != 'subdocuments'">
            {{ ( title != 'Users' ? title:'') | translate }} 
            <v-spacer></v-spacer>
            <v-btn v-if="title =='Items Board' || settingsstatus == 'true'" v-on:click="settingsdialog()" class="white--text" :color="primary_color">{{ 'Settings'| translate }}</v-btn>
            <v-btn v-if="title==='Users'&& Object.keys(currentUser).length !=0" v-on:click="settings()" class="mr-2 white--text" :color="primary_color">{{ 'Settings'| translate }}</v-btn>
            <v-btn v-if="title==='Users' && Object.keys(currentUser).length !=0 && currentUser.roles.includes(1) == true" v-on:click="inviteUsers()"  class="white--text" :color="primary_color">{{ 'Invite Users'| translate }}</v-btn>
          </v-card-title>
          <v-toolbar v-if="title !='Module details'" flat color="white">
            <v-spacer></v-spacer>
            <v-text-field v-if="title !='Module details' || title != 'subdocuments'" v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
          </v-toolbar>       
          </template> 
          <template v-slot:item.personaldocumentaction ="{ item }">
               <v-icon
                  small
                  class="mr-2"
                  v-on:click="previewTemplate(item.temp_file_id)"
              >mdi-eye</v-icon> 
              <v-icon small class="mr-2" v-if="item.status == 'active'" v-on:click="editing(item)">edit</v-icon>
          </template> 
          <template v-slot:item.view ="{ item }">
              <v-btn small class="white--text" :color="primary_color" v-on:click="download(item.ud_id, item.doc_id, item.extension)">{{ 'View'| translate }}</v-btn>
          </template> 
          <template v-slot:item.view_certificate="{ item }">
              <v-btn small class="white--text" :color="primary_color" v-on:click="downloadcerti(item.cert_id, item.course_name, 'pdf')">{{ 'View'| translate }}</v-btn>
          </template> 
          <template v-slot:footer.page-text="items"> 
            {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
          </template>

        <template v-slot:item.launch="{ item }">
          <div class="my-2">
            <v-btn small :color="primary_color" v-on:click="handlePlay(item.module_id)">{{ 'Launch'| translate }}</v-btn>
          </div>
        </template>
        <template v-slot:item.pdf="{ item }">
          <div class="my-2">
            <v-btn small class="white--text" :color="primary_color" :href='item.invoice_pdf' rel="noopener noreferrer" target="_blank">{{ 'Download PDF'| translate }}</v-btn>
          </div>
        </template>   
        <template v-slot:header="{ props: { headers } }">
          <!-- <thead v-if="!isMobile">
            <tr>
              <th v-for="(header, index) in headers" :key="index">
                {{ header.text | translate}}
              </th>
            </tr>
          </thead> -->
        </template>
        <template v-slot:item.moduleprogress="{ item }">
          <div class="text-left" v-if="item.is_passed == true">
            <v-progress-circular 
              :rotate="360"
              :size="70"
              :width="10"
              :value="100"
              color="teal"
            ><v-icon color="teal">mdi-checkbox-marked-circle</v-icon></v-progress-circular>
          </div>
          <div class="text-left" v-else>
            <v-progress-circular 
              :rotate="360"
              :size="70"
              :width="10"
              :value="(item.module_progress>100 ? 100: item.module_progress)"
              color="teal"
            >{{ (item.module_progress>=100 ? 100: item.module_progress) }}</v-progress-circular>
          </div>
        </template>

        <template v-slot:item.file="{ item }">
            <span v-if="item.resource_type=='image'">   
               <v-img
                :src="company_storage_url+item.file"
                :alt="item.name"
                height="180px"
                width="170px"
              ></v-img> 
            </span>
            <span v-else>
              <a :href="item.file" target="_blank">{{item.file}}</a>
            </span>
        </template>
        <template v-slot:item.is_passed="{ item }"   >
            {{ (item.is_passed ? 'PASSED' : 'FAILED' )| translate }}
        </template>
      </v-data-table>
    </v-skeleton-loader>

</template>

<style lang="scss">
.v-data-footer {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.v-application--is-ltr .v-data-footer__select {
  margin-left: 16px !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import {
  DOWNLOAD_USER_DOCUMENT,
  FETCH_INDIVIDUAL_CERTIFICATE
} from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type"

export default {
  name: "DataTable",
  computed: {
    ...mapGetters(["loadingdata",'routerenter', 'userdocuments','currentUser', 'loggedin']),
    footertext(){
      return this.$t('Rows per page')
    },
    userdocumentheaders(){
      return [
        { text: this.$t("Type"), value: "doc_name" }, 
        { text: this.$t("Status"), value: "status" },       
        { text: this.$t("Due date"), value: "due_date" },  
        { text: this.$t("Uploaded by"), value: "uploaded_user" },  
        { text: this.$t("Uploaded on"), value: "updated_at" },
        {text: this.$t('View'), value:'view'},
      ]
    },
  },  
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
  },
  methods: {
    onResize() {
      if (window.innerWidth < 600) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },  
    settingsdialog(){
      this.$emit("openSettingsDialog")
    },
    settings(){
      this.$emit("settingsregistration")
    },  
    handleClick(id) {
      this.$emit("editing", id);
    },
    handlePlay(id) {
      this.$emit("play", id);
    },
    handleDetails(id){
      this.$emit("details",id);
    }, 
    handleView(id){
      this.$emit("showView", id);
    },
    showDocuments(id){
      this.$emit('showDocuments',id);
    },
    inviteUsers(){
      this.$emit("csvmodal")
    },
    handleDelete(id){
      this.$emit("deleting",id)
    },
    handleRevoke(id){
      this.$emit("revoking",id)
    },
    changeState(user){
      this.$emit("changestatus",user)
    },
    editing(data){
      this.$emit("editing",data)
    },
    previewTemplate(data){
      this.$emit("previewTemplate",data)
    },
    openDocumentModal (data) {
      this.$emit("modalOpenDocument",data)
    },
    getRoleColor(role_id){
      switch(role_id){
        case 'company-admin' :
          return 'red';
        case 'auditor' :
          return 'yellow';
        case 'group-admin' :
          return 'green';
        case 'user' :
          return 'blue';
        case 'tester' :
          return 'orange';
        default :
          return 'grey';
      }
    },
    async download(id, name , extension){
      await this.$store
        .dispatch(DOWNLOAD_USER_DOCUMENT, 'view-file/'+id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          this.$store.commit(SET_LOADING, false);

        });
    },
    async downloadcerti(id, name, extension){
      await this.$store
        .dispatch(FETCH_INDIVIDUAL_CERTIFICATE, 'course-certificates/view-file/'+id)
        .then(resp => {
          let byteCharacters = atob(resp.data);
          let byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], { type: 'application/pdf;base64' });
          let fileURL = URL.createObjectURL(file);
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
  data() {
    return {
      interval: {},
      csvfile:null,
      isMobile: false,
      storage_url: '',
      hidden_status: false,
      visible_status: true, 
      expanded: [],
      hidefooteruser: 'false',
      userdocumenttitle:'subdocuments',     
      userdocumentexpandable: 'false',
      searchuser: '',
      primary_color: null,
    };
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  created (){
    this.storage_url  = process.env.VUE_APP_STORAGE_URL
    this.company_storage_url  = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color;
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  }, 
  props: {
    selected: Array,
    search: String,
    headers: Array,
    items: Array,
    title: String,
    footerstatus: String,
    singleexpand: String,
    itemkeyvalue: String,
    showexpandstatus: String,
    settingsstatus: String,
    actiontitle: String,
  }
};
</script>
